// extracted by mini-css-extract-plugin
export default {"container":"LegalData_container__VfLh2","link":"LegalData_link__4IHFo"};